import React, { useState } from "react";
import {
  allowOnlyNumbers,
  stopEventPropagation,
} from "../../../../utiles/helpers";
import CloseButton from "../../../../assets/icon/CloseIcon";
import CancelButton from "../../../common/button/CancelButton";
import { removeWhitespace } from "../../../../utiles/helpers";
import SubmitButton from "../../../common/button/SubmitButtton";
import useShowAlert from "../../../../utiles/AlertUtiles";
import useErrorHandle from "../../../../constant/errorHandling/useErrorHandle";
import uRLs from "../../../../utiles/BaseUtile";

function AddStores({ onClose }) {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [storeTitle, setStoreTitle] = useState("");
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [VerifyToken, setVerifyToken] = useState("");

  const showAlert = useShowAlert();
  const handleError = useErrorHandle();

  const [loadingState, setLoadingState] = useState({
    email: false,
    otp: false,
    store: false,
  });

  const handleEmailSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!email.trim()) {
      setError("Email is required.");
      return;
    }
    setLoadingState((prev) => ({ ...prev, email: true }));

    setError("");

    try {
      const res = await fetch(`${uRLs.AUTH_URL}auth-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email }),
      });
      const data = await res.json();
      if (data.status) {
        showAlert("success", data.message);
        setVerifyToken(data?.results.verifyToken);
        setStep(2);
      } else {
        setError(data.message || "Something went wrong.");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState((prev) => ({ ...prev, email: false }));
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();

    if (!otp.trim()) {
      setError("OTP is required.");
      return;
    } else if (otp.trim().length < 6) {
      setError("OTP must be at least 6 digits.");
      return;
    }
    setLoadingState((prev) => ({ ...prev, otp: true }));
    setError("");
    try {
      const res = await fetch(`${uRLs.AUTH_URL}auth-email-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${VerifyToken}`,
        },
        body: JSON.stringify({ verifycode: otp }),
      });
      const data = await res.json();
      if (data.status && data.results?.accessToken) {
        showAlert("success", data.message);
        setAccessToken(data.results.accessToken);
        setStep(3);
      } else {
        setError(data.message || "Invalid OTP.");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState((prev) => ({ ...prev, otp: false }));
    }
  };

  const handleStoreSubmit = async (e) => {
    e.preventDefault();

    if (!storeTitle.trim()) {
      setError("Store title is required.");
      return;
    }
    setLoadingState((prev) => ({ ...prev, store: true }));
    setError("");
    try {
      const res = await fetch(`${uRLs.API_URL}add-store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ title: storeTitle }),
      });
      const data = await res.json();
      if (data.status) {
        showAlert("success", data.message);
        onClose();
      } else {
        setError(data.message || "Failed to add store.");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState((prev) => ({ ...prev, store: false }));
    }
  };
  const handleBackStore = () => {
    setError("");
    setOtp("");
    setEmail("");
    setStep(1);
  };
  const handleBack = () => {
    setError("");
    setOtp("");
    setStep(1);
  };
  const handleResendOTP = () => {
    setError("");
    setOtp("");
    handleEmailSubmit();
  };
  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal fade show d-block"
        id="ExpenseModal"
        tabIndex="-1"
        aria-labelledby="ExpenseModalLabel"
        aria-hidden="false"
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
          onClick={stopEventPropagation}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">
                {step === 1 && "Email Veification"}
                {step === 2 && " OTP Veification"}
                {step === 3 && "Add Store"}
              </h6>
              <CloseButton onClick={onClose} />
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  {step === 1 && (
                    <form onSubmit={handleEmailSubmit} className="row g-3">
                      <div className="col-12">
                        <label htmlFor="email" className="form-label text-left">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="email"
                          autoComplete="off"
                          value={email}
                          onChange={(e) => {
                            setError("");
                            setEmail(
                              removeWhitespace(
                                e.target.value.trim().toLowerCase()
                              )
                            );
                          }}
                        />
                        <div className="pt-2">
                          {error && (
                            <small className="text-danger pt-2">{error}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-12 mt-2 d-flex justify-content-end">
                        <SubmitButton
                          label="Send OTP"
                          loading={loadingState.email}
                        />
                      </div>
                    </form>
                  )}

                  {step === 2 && (
                    <>
                      <p className="text-center ">
                        One Time Password (OTP) has been sent successfully to
                        email <b>"{email}"</b>
                      </p>

                      <form onSubmit={handleOtpSubmit} className="row g-3">
                        <div className="col-12">
                          <label htmlFor="otp" className="form-label text-left">
                            Enter OTP <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="otp"
                            maxLength={6}
                            autoComplete="off"
                            value={otp}
                            onChange={(e) => {
                              setError("");
                              setOtp(allowOnlyNumbers(e.target.value));
                            }}
                            pattern="[0-9]*" 
                              inputMode="numeric"
                          />
                          <div className="pt-2">
                            {error && (
                              <small className="text-danger pt-2">
                                {error}
                              </small>
                            )}
                          </div>
                        </div>
                        <div
                          className="col-md-12 text-end mt-1 text-blue"
                          onClick={handleResendOTP}
                        >
                          {loadingState.email ? (
                            <div
                              className="spinner-border spinner-border-sm"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            "Resend OTP"
                          )}
                        </div>

                        <div className="col-12 d-grid mt-2">
                          <SubmitButton
                            label="Verify OTP"
                            loading={loadingState.otp}
                          />
                        </div>
                        <div className="d-grid mt-3">
                          <div className="btn btn-light" onClick={handleBack}>
                            Back To Login
                          </div>
                        </div>
                      </form>
                    </>
                  )}

                  {step === 3 && (
                    <form onSubmit={handleStoreSubmit} className="row g-3">
                      <div className="col-12">
                        <label
                          htmlFor="storeTitle"
                          className="form-label text-left"
                        >
                          Store Title <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="storeTitle"
                          autoComplete="off"
                          value={storeTitle}
                          onChange={(e) => {
                            setError("");
                            setStoreTitle(e.target.value);
                          }}
                        />
                        <div className="pt-2">
                          {error && (
                            <small className="text-danger pt-2">{error}</small>
                          )}
                        </div>
                      </div>
                      <div className="col-12 d-grid mt-2">
                        <SubmitButton
                          label="Add Store"
                          loading={loadingState.store}
                        />
                      </div>
                      <div className="d-grid mt-3">
                        <div
                          className="btn btn-light"
                          onClick={handleBackStore}
                        >
                          Back To Login
                        </div>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer d-block">
              <CancelButton
                buttonText="Close"
                buttonIcon="bx bx-x"
                onClick={onClose}
                additionalClasses="btn-outline-secondary pull-right"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddStores;
